<template>
  <div class="videoplayer-comp">
    <div
      ref="container"
      class="videoplayer-container"
      :style="{ flex: urn ? 1 : 0 }"
    ></div>
  </div>
</template>

<script>
import SRGLetterbox from "@srgssr/srgletterbox-web";
import "@srgssr/srgletterbox-web/dist/letterbox.css";
export default {
  props: ["urn"],
  mounted() {
    this.options.container = this.$refs.container;
    this.player = new SRGLetterbox(this.options);
    this.addPlayerListeners();
    if (this.urn) {
      this.playEvent(this.urn);
    }
  },
  beforeUnmount() {
    this.player.dispose();
    this.removeListener();
  },
  // watch: {
  //   currentEvent() {
  //     if (this.currentEvent && this.isMainEvent) {
  //       // prevent possible racing condition from pending timeout on error
  //       clearTimeout(this.retryOnPlayerErrorTimeout);
  //       // if we're past and the event was limited-DVR, we play the first highlight.
  //       if (
  //         this.currentEvent.limitedDVR &&
  //         this.currentEvent.category === "past"
  //       ) {
  //         this.playFirstHighlight = true;
  //       } else {
  //         this.playEvent(this.urn);
  //       }
  //       this.canPlayTimeout = setTimeout(() => {
  //         events.publish("HTML5_PLAYER_STREAM_READY", false);
  //       }, 5000);
  //       this.player.one("srgssr/mediaCompositionLoaded", () => {
  //         clearTimeout(this.canPlayTimeout);
  //         events.publish("HTML5_PLAYER_STREAM_READY", true);
  //       });
  //     }
  //   },
  //   isPlayingMainEvent(a, b) {
  //     if (a && !b && this.urn) {
  //       this.isMainEvent = true;
  //       // prevent possible racing condition from pending timeout on error
  //       clearTimeout(this.retryOnPlayerErrorTimeout);
  //       this.playEvent(this.urn);
  //     }
  //   }
  // },
  methods: {
    addPlayerListeners() {
      // workaround for bug in letterpress
      // https://jira.srg.beecollaboration.com/browse/SRC-5973
      // https://jira.srg.beecollaboration.com/browse/SRC-5974
      // video after countdown never starts
      // video that reaches end of event will stop abruptly
      // bug for both cases can be reproduced here by providing an event in the future and wait until the event ends
      // https://srgssr.github.io/srgletterbox-web-demo/?projectKey=SRC&view=planning&selectedIssue=SRC-5974&issueLimit=100&lang=fr&env=il.srgssr.ch&branch=production&ratio=1&debug=true&size=default&urn=urn:swisstxt:video:srf:1703648&castAppId=1AC2931D
      /*
      const retriesCounters = {};
      this.player.on("error", (err) => {
        const playerError = this.player.error();
        const playerUrn = this.player.getUrn();
        // code 4 stands for MEDIA_ERR_SRC_NOT_SUPPORTED, no type provided -> thrown after countdown letterpress thinks src is not supported
        // code 19 stands for undefined -> thrown after event ends
        if (
          playerError.code === 4 ||
          (playerError.code === 19 && playerError.type === "ERROR_UNKNOWN")
        ) {
          // safety check, to not hammer, if something goes badly wrong
          if (!retriesCounters[playerUrn]) {
            retriesCounters[playerUrn] = 1;
          } else {
            retriesCounters[playerUrn] += 1;
          }
          if (retriesCounters[playerUrn] > 5) {
            // console.log("retried on urn more than 5 time. aborting.", playerUrn)
            return;
          }
          // console.log("try to load urn on error again: ", playerError, err)
          this.retryOnPlayerErrorTimeout = setTimeout(() => {
            this.playEvent(playerUrn);
          }, (retriesCounters[playerUrn] || 5) * 1000);
        }
      });
      */
      // this.player.on("srgssr/subdivisionVisibilityChanged", data => {
      //   if (data.data?.hasSubdivisions) {
      //     this.hasHighlights = true;
      //   } else {
      //     this.hasHighlights = false;
      //   }
      // });
    },
    // addListener() {
    //   const that = this;
    //   this.eventFns[events.HIGHLIGHT_NAVIGATION_PLAY_HIGHLIGHT] = function(
    //     highlight
    //   ) {
    //     that.playHighlight(highlight);
    //   };
    //   this.eventFns[events.TICKER_VIDEO_PLAY_EVENT] = function(highlight) {
    //     that.playHighlight(highlight);
    //   };
    //   this.eventFns[events.LOAD_SRG_PLAY] = function(id) {
    //     that.playEvent(id);
    //   };
    //   this.eventFns[events.PLAY_VIDEO_URN] = function(o) {
    //     that.playHighlight(o);
    //   };
    //   events.subscribe(
    //     events.HIGHLIGHT_NAVIGATION_PLAY_HIGHLIGHT,
    //     this.eventFns[events.HIGHLIGHT_NAVIGATION_PLAY_HIGHLIGHT]
    //   );
    //   events.subscribe(
    //     events.TICKER_VIDEO_PLAY_EVENT,
    //     this.eventFns[events.TICKER_VIDEO_PLAY_EVENT]
    //   );
    //   events.subscribe(
    //     events.PLAY_VIDEO_URN,
    //     this.eventFns[events.PLAY_VIDEO_URN]
    //   );
    // },
    // removeListener() {
    //   events.off(
    //     events.HIGHLIGHT_NAVIGATION_PLAY_HIGHLIGHT,
    //     this.eventFns[events.HIGHLIGHT_NAVIGATION_PLAY_HIGHLIGHT]
    //   );
    //   events.off(
    //     events.TICKER_VIDEO_PLAY_EVENT,
    //     this.eventFns[events.TICKER_VIDEO_PLAY_EVENT]
    //   );
    //   events.off(events.PLAY_VIDEO_URN, this.eventFns[events.PLAY_VIDEO_URN]);
    // },
    playEvent(urn) {
      this.player.loadUrn(urn);
    }
    // playHighlight(highlight) {
    //   const { urn } = highlight;
    //   try {
    //     this.$refs.container.scrollIntoView();
    //   } catch (err) {
    //     console.error(err);
    //   }
    //   this.$store.dispatch("live/setCurrentHighlight", highlight);
    //   if (this.currentEvent && urn.indexOf(this.currentEvent.urn) > -1) {
    //     this.player.switchToUrn(urn);
    //   } else {
    //     this.isMainEvent = false;
    //     this.player.loadUrn(urn);
    //   }
    // }
  },
  data() {
    return {
      isMainEvent: true,
      canPlayTimeout: null,
      hasHighlights: false,
      playFirstHighlight: false,
      eventFns: {},
      options: {
        analytics: null,
        container: null,
        chromeCastReceiver: "1AC2931D",
        debug: null,
        fillMode: true,
        ilHost: "il.srgssr.ch",
        language: null,
        mediaStatistic: null,
        playerFocus: undefined,
        recommendations: false,
        storageNamespace: "srgssr/letterbox/userStorage",
        components: {
          controlBar: true,
          header: false,
          sharing: false,
          title: false,
          thumbnails: false,
          playButton: true,
          subdivisions: false
        },
        audioTrackLanguage: {
          default: false,
          storage: true
        },
        autoplay: {
          default: true,
          storage: true
        },
        continuousPlayback: {
          default: false,
          storage: false
        },
        hd: {
          default: true,
          storage: true
        },
        muted: {
          default: false,
          storage: true
        },
        playbackRate: {
          default: 1,
          storage: false
        },
        textTrackLanguage: {
          default: false,
          storage: true
        },
        textTrackSizeLevel: {
          default: 1,
          storage: true
        },
        volume: {
          default: 1,
          storage: true
        }
      }
    };
  }
};
</script>

<style lang="scss">
// poc to achieve overlapping highlights while have some transitions
// still working nicely with what is given by the letterbox
.videoplayer-comp.widget .letterbox-web .vjs-srgssr-skin {
  // stay in tune with the page font size
  font-size: 12px;
  // make the video take up all the space
  .vjs-tech {
    height: 100%;
  }
  .vjs-poster {
    height: 100%;
  }

  // transitions for showing / hiding controls, highlights
  &.vjs-user-active {
    // override the bottom transition, with visibility toggle, for controls
    .vjs-control-bar {
      transition: visibility 0s linear 0s, opacity 0.5s ease-out !important;
    }
    // add transition that is in sync with control bar
    .srgssr-subdivisions {
      visibility: visible;
      opacity: 1;
      transition: visibility 0s linear 0s, opacity 0.5s ease-out;
      background-color: rgba(0, 0, 0, 0.6);
      .subdivision {
        background-color: rgba(0, 0, 0, 0.75);
        &.subdivision--selected {
          background-color: #96001a;
        }
      }
    }
  }

  // same as show but the revers
  &.vjs-user-inactive {
    .vjs-control-bar {
      transition: visibility 0s linear 0.5s, opacity 0.5s ease-in,
        bottom 0s linear 0.5s !important;
    }
    .srgssr-subdivisions {
      visibility: hidden;
      opacity: 0;
      transition: visibility 0s linear 0.5s, opacity 0.5s ease-in;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
  // to stay consistent with paused behaviour for controls
  // always show the highlights on pause
  .vjs-user-active,
  .vjs-user-inactive {
    &.vjs-paused {
      .srgssr-subdivisions {
        visibility: visible;
        opacity: 1;
      }
    }
  }
}
</style>
